import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const SAFETY_SIGNAL_DETECTION_RUN_HISTORY_CODE: {
  SIGNAL_DETECTION_RUN_HISTORY_ALREADY_WAITING: MvnCodeBE;
} = {
  SIGNAL_DETECTION_RUN_HISTORY_ALREADY_WAITING: {
    status: 409,
    ko: "이미 대기 중인 실행 이력이 존재합니다.",
    en: "A run history in WAIT status already exists for this profile.",
  },
};

MvnCodeInitiate(SAFETY_SIGNAL_DETECTION_RUN_HISTORY_CODE);
